import { InputLabel, Input } from "@mui/material";
import { Box, Button, Fade, FormControl, Grid, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import Controls from "../components/controls/Controls";
import { addIcon } from "../config/services/icon";
import toast from 'react-hot-toast';

export function IconApp() {
  const [iconFile, setIconFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    setIconFile({ fileName: file.name, file: file });
  };

  const handleUpload = async () => {
    setIsUploading(true);
    const formData = new FormData();
    formData.append('icon', iconFile.file);
    const res = await addIcon(formData);
    if (res.message) {
      toast.success(res.message);
      setIconFile(null);
      setIsUploading(false);
    }
    else {
      toast.error('Something went wrong!');
      setIsUploading(false);
    }
  };

  const handleClear = () => {
    setIconFile(null);
  };

  return (
    <div>
      <Fade in={true}>
        <Box style={{ maxHeight: '80vh' }} className="modal-paper modal-box modal-lg" id="transition-modal-title">
          <Box className="modal-header" >
            <Typography variant="subtitle1" className="modal-header-title">Icon upload</Typography>
          </Box>
          <Box className="modal-content">
            <Stack direction="column" width="100%">
              <FormControl>
                <Button
                  variant="contained"
                  component="label"
                  className="report_form_ui_btn cancel mr-2 mt-2"
                >
                  {iconFile ? 'Change File' : 'Select File'}
                  <input
                    type="file"
                    accept=".svg"
                    hidden
                    onChange={handleFileSelect}
                  />
                </Button>
              </FormControl>
              <InputLabel style={{ fontSize: '12px', marginTop: '10px' }}>{iconFile?.fileName}</InputLabel>
            </Stack>
            <Grid mt={5}>
              <Controls.Button
                className="report_form_ui_btn cancel mr-2"
                color="secondary"
                text="Clear"
                onClick={handleClear}
              />
              <Controls.Button
                className="report_form_ui_btn submit"
                type="submit"
                text="upload"
                onClick={handleUpload}
                disabled={!iconFile}
              />
            </Grid>
          </Box>
        </Box>
      </Fade>
    </div>
  );
}